let containerRect;
let tooltipRect;
let tooltipWidth;
let tooltipRef;
let windowWidth;
let windowHeight;
let scrollX;
let scrollY;
let parentNode;
let offsetTop;
let offsetLeft;

function setPositionTop() {
  if (parentNode) {
    tooltipRef.style.top = `${offsetTop - tooltipRect.height}px`;
    tooltipRef.style.left = `${offsetLeft + containerRect.width / 2 - tooltipWidth / 2}px`;
  } else {
    tooltipRef.style.top = `${scrollY + containerRect.top - tooltipRect.height - 8}px`;
    tooltipRef.style.left = `${scrollX + containerRect.left + containerRect.width / 2 - tooltipWidth / 2}px`;
  }
}

function setPositionRight() {
  if (parentNode) {
    tooltipRef.style.top = `${offsetTop + containerRect.height / 2 - tooltipRect.height / 2}px`;
    tooltipRef.style.left = `${offsetLeft + containerRect.width}px`;
  } else {
    tooltipRef.style.top = `${scrollY + containerRect.top - tooltipRect.height / 2 + containerRect.height / 2}px`;
    tooltipRef.style.left = `${scrollX + containerRect.right + 8}px`;
  }
}

function setPositionBottom() {
  if (parentNode) {
    tooltipRef.style.top = `${offsetTop + containerRect.height}px`;
    tooltipRef.style.left = `${offsetLeft + containerRect.width / 2 - tooltipWidth / 2}px`;
  } else {
    tooltipRef.style.top = `${scrollY + containerRect.bottom + 8}px`;
    tooltipRef.style.left = `${scrollX + containerRect.left + containerRect.width / 2 - tooltipWidth / 2}px`;
  }
}

function setPositionLeft() {
  if (parentNode) {
    tooltipRef.style.top = `${offsetTop + containerRect.height / 2 - tooltipRect.height / 2}px`;
    tooltipRef.style.left = `${offsetLeft - tooltipWidth}px`;
  } else {
    tooltipRef.style.top = `${scrollY + containerRect.top - tooltipRect.height / 2 + containerRect.height / 2}px`;
    tooltipRef.style.left = `${scrollX + containerRect.left - tooltipWidth - 8}px`;
  }
}

export default function(parent, container, ttRef, position, maxWidth) {
  containerRect = container.getBoundingClientRect();
  ttRef.classList.add('uni-tooltip--is-shown');
  tooltipRect = ttRef.getBoundingClientRect();
  ttRef.classList.remove('uni-tooltip--is-shown');
  tooltipWidth = maxWidth ? maxWidth : tooltipRect.width;
  tooltipRef = ttRef;
  windowWidth = document.documentElement.scrollWidth;
  windowHeight = document.documentElement.scrollHeight;
  scrollX = window.scrollX;
  scrollY = window.scrollY;
  parentNode = parent;
  offsetTop = container.offsetTop;
  offsetLeft = container.offsetLeft;

  let newPosition;

  if (position === 'top') {
    if (containerRect.top > tooltipRect.height) {
      setPositionTop();
      newPosition = 'top';
    } else {
      setPositionBottom();
      newPosition = 'bottom';
    }
  } else if (position === 'right') {
    if (windowWidth - containerRect.right > tooltipRect.width) {
      setPositionRight();
      newPosition = 'right';
    } else {
      setPositionLeft();
      newPosition = 'left';
    }
  } else if (position === 'bottom') {
    if (windowHeight - containerRect.bottom > tooltipRect.height) {
      setPositionBottom();
      newPosition = 'bottom';
    } else {
      setPositionTop();
      newPosition = 'top';
    }
  } else if (position === 'left') {
    if (containerRect.left > tooltipRect.width) {
      setPositionLeft();
      newPosition = 'left';
    } else {
      setPositionRight();
      newPosition = 'right';
    }
  }

  return newPosition;
}



// WEBPACK FOOTER //
// ./src/__utils/tooltipHelpers.js